import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InviteModalComponent } from '../invite-modal/invite-modal.component';
import { UserService } from '../../../services/user.service';
import { Role, TeamMember } from '../../../models/team.model';
import { DeleteModalComponent } from '../delete-modal/delete-modal.component';
import { ToastNotificationService } from '../../../services/toast-notification.service';
import { findFirstNonEmptyString } from '../../../utils';
import { User } from '../../../models/user.model';
import { InlineSvgComponent } from '../../../components/inline-svg/inline-svg.component';
import { NgClass } from '@angular/common';
import { UserLogoComponent } from '../../../components/user-logo/user-logo.component';
import { MatSelect } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';


@Component({
  selector: 'frmg-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
  imports: [InlineSvgComponent, NgClass, UserLogoComponent, MatSelect, ReactiveFormsModule, FormsModule, MatOption]
})
export class TeamComponent implements OnInit {
  public teamData: TeamMember[] = [];
  public availableRoles: Role[] = [];
  public availableMembership: string[] = ['member', 'owner'];
  public displayedColumns = ['user', 'fullName', 'role', 'action'];
  public currentUser: User;
  public currentUserRole: string = 'member';
  public pageSize = 5;
  public totalElements = 0;
  public currentPage = 1;
  public lastPage = 0;

  constructor(private dialog: MatDialog,
              private userService: UserService,
              private toastNotificationService: ToastNotificationService) {
  }

  ngOnInit(): void {
    this.currentUser = this.userService.getUser();
    this.currentUserRole = this.currentUser.teams[0].membership.role;
    this.getTeamMembers();
    this.userService.getTeamRoles().subscribe(rolesPage => {
      this.availableRoles = rolesPage.results;
    });
  }

  getTeamMembers(): void {
    this.userService.getInvitedUsers().subscribe(
      (invitedUsers) => {
        this.userService.getTeamUsers(this.currentPage, this.pageSize).subscribe(
          (response) => {
            this.totalElements = response.count;
            this.lastPage = Math.ceil(this.totalElements / this.pageSize);
            this.teamData = [...invitedUsers.results.filter(member => !member.is_accepted), ...response.results.map(member => {
              member.is_accepted = true;
              if (!member.role_team) member.role_team = {};
              return member;
            })];
          },
          () => {
            const errorMsg = 'Error fetching team members:';
            this.toastNotificationService.showNotification({ type: 'error', message: errorMsg });
          }
        );
      }
    );
  }

  public changePageSize(size: number): void {
    if (this.pageSize === size) return;
    this.pageSize = size;
    this.getTeamMembers();
  }

  public changePage(page: number): void {
    if (this.currentPage === page) return;
    this.currentPage = page;
    this.getTeamMembers();
  }

  removeMember(): void {
    this.dialog.open(DeleteModalComponent).afterClosed().subscribe(resp => {
      if (resp) {
        this.userService.removeTeamUser()
          .subscribe(
            () => {
              this.toastNotificationService.showNotification({ type: 'success', message: 'User was deleted successfully.' });
              this.getTeamMembers();
            },
            (error) => {
              const errorMsg = 'Error removing team member';
              this.toastNotificationService.showNotification({ type: 'error', message: findFirstNonEmptyString(error.error) || errorMsg });
            }
          );
      }
    });
  }

  revokeUser():void {
    this.dialog.open(DeleteModalComponent).afterClosed().subscribe(resp => {
      if (resp) {
        this.userService.revokeInvitedUser()
          .subscribe(
            () => {
              this.toastNotificationService.showNotification({ type: 'success', message: 'User was deleted successfully.' });
              this.getTeamMembers();
            },
            (error) => {
              const errorMsg = 'Error removing team member';
              this.toastNotificationService.showNotification({ type: 'error', message: findFirstNonEmptyString(error.error) || errorMsg });
            }
          );
      }
    });
  }

  openInviteModal(): void {
    this.dialog.open(InviteModalComponent).afterClosed().subscribe(resp => {
      if (resp) this.getTeamMembers();
    });
  }

  setMembership(): void {
    this.userService.updateTeamUser().subscribe(newMember => {
      const index = this.teamData.findIndex(member => member.id === newMember.id);
      this.teamData[index] = newMember;
    }, error => {
      const errorMsg = 'Error changing membership';
      this.toastNotificationService.showNotification({ type: 'error', message: findFirstNonEmptyString(error.error) || errorMsg });
    });
  }
}
